$(document).ready(function(){

  var otherCheckbox = document.getElementById('otherCheckbox');
  var otherTextField = document.getElementById('otherTextField');

  if (otherCheckbox && otherTextField) {
    otherCheckbox.addEventListener('change', function () {
      if (this.checked) {
        otherTextField.classList.add('show');
      } else {
        otherTextField.classList.remove('show');
      }
    });
  }

  // When the form was first rendered (used to detect bot-speed submissions)
  var formLoadTime = Date.now();
  var MIN_FILL_SECONDS = 4;          // real users never fill this fast
  var SUBMIT_COOLDOWN_MS = 30000;    // per-browser cooldown

  $('body').on("click", ".warranty_activation_submit", function(e) {
    e.preventDefault();
    e.stopPropagation();

    var _this = $(this);
    var form = _this.closest("form");
    var success_msg = _this.attr("data-success") || "Serial number submitted successfully. Your warranty is now active.";

    // ── Defense #1: Honeypot ─────────────────────────────────────
    // HTML must include a hidden input bots will blindly fill, e.g.:
    //   <input type="text" name="website_url" tabindex="-1" autocomplete="off"
    //          style="position:absolute;left:-9999px;opacity:0;height:0;width:0;" />
    var honeypot = form.find('input[name="website_url"]').val();
    if (honeypot && honeypot.trim() !== '') {
      // Show fake success so bots don't learn we caught them
      console.warn("Honeypot triggered.");
      _this.parent().append('<p class="message_after_call">' + success_msg + '</p>');
      return;
    }

    // ── Defense #2: Time-to-fill ─────────────────────────────────
    var elapsed = (Date.now() - formLoadTime) / 1000;
    if (elapsed < MIN_FILL_SECONDS) {
      console.warn("Form submitted in", elapsed, "seconds.");
      _this.parent().append('<p class="message_after_call">' + success_msg + '</p>');
      return;
    }

    // ── Defense #3: Per-browser throttle ─────────────────────────
    try {
      var lastSubmit = parseInt(sessionStorage.getItem('warranty_last_submit') || '0', 10);
      if (Date.now() - lastSubmit < SUBMIT_COOLDOWN_MS) {
        _this.parent().append('<p class="message_after_call">Please wait a moment before submitting again.</p>');
        return;
      }
    } catch (e) { /* sessionStorage unavailable, skip */ }

    // ── Defense #4: Cloudflare Turnstile token ───────────────────
    // Requires in HTML:
    //   <script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
    //   <div class="cf-turnstile" data-sitekey="YOUR_SITE_KEY"></div>
    var turnstileToken = form.find('input[name="cf-turnstile-response"]').val();
    if (typeof turnstile !== 'undefined' && !turnstileToken) {
      _this.parent().append('<p class="message_after_call">Please complete the security check.</p>');
      return;
    }

    var isValid = true;
    form.find('.error').remove();

    form.find('.field--with-error input, .field--with-error textarea').each(function () {
      var field = $(this);
      var val = field.val().trim();
      var type = field.attr('type');
      var pattern = field.attr('pattern');

      if (!val) {
        field.closest('.field').after("<p class='error'>*This field is required.</p>");
        isValid = false;
        return;
      }

      // Length cap blocks 10,000-char garbage payloads
      if (val.length > 500) {
        field.closest('.field').after("<p class='error'>*Input is too long.</p>");
        isValid = false;
        return;
      }

      if (pattern) {
        try {
          // Anchor the pattern so attackers can't smuggle junk around a valid match
          var regex = new RegExp('^(?:' + pattern + ')$');
          if (!regex.test(val)) {
            field.closest('.field').after("<p class='error'>*Invalid format.</p>");
            isValid = false;
            return;
          }
        } catch (e) {
          console.warn("Invalid regex pattern:", pattern);
        }
      }

      if (type === 'email') {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
          field.closest('.field').after("<p class='error'>*Enter a valid email address.</p>");
          isValid = false;
          return;
        }
        // Block obvious disposable/test domains
        var blockedDomains = ['mailinator.com','tempmail.com','10minutemail.com','guerrillamail.com','test.com','example.com','yopmail.com','sharklasers.com'];
        var domain = val.split('@')[1].toLowerCase();
        if (blockedDomains.indexOf(domain) !== -1) {
          field.closest('.field').after("<p class='error'>*Please use a real email address.</p>");
          isValid = false;
          return;
        }
      }
    });

    if (!isValid) return;

    try { sessionStorage.setItem('warranty_last_submit', Date.now().toString()); } catch (e) {}

    _this.text("Processing...");
    _this.prop("disabled", true);
    form.find('.message_after_call').remove();

    var data_form = form.serializeArray();

    // Handle "find_us"
    let findUsValues = form.find("input[name='find_us']:checked").map(function () {
      return $(this).val();
    }).get();

    let findUsOther = $('#other_find_id').val();

    if ($('#otherCheckbox').is(':checked') && findUsOther && findUsOther.trim()) {
      findUsValues.push(findUsOther.trim());
    }

    data_form = data_form.filter(function(field) {
      return field.name !== 'find_us' && field.name !== 'website_url';
    });

    data_form.push({ name: 'find_us', value: findUsValues.join(', ') });

    // Pass the Turnstile token explicitly so the backend can verify it
    if (turnstileToken) {
      data_form.push({ name: 'cf_turnstile_token', value: turnstileToken });
    }

    $.post(form.attr('action'), data_form)
      .done(function(data, status) {
        if (data && (data.success === true || status === 'success')) {
          _this.parent().append('<p class="message_after_call">' + success_msg + '</p>');
        } else {
          _this.parent().append('<p class="message_after_call">Submission failed. Please contact us.</p>');
        }
      })
      .fail(function(xhr, status, error) {
        console.error("AJAX Error:", status, error);
        _this.parent().append('<p class="message_after_call">Email or serial number do not match the order number. Please contact us.</p>');
      })
      .always(function() {
        _this.text("Submit");
        _this.prop("disabled", false);

        // Reset Turnstile so the user can submit again with a fresh token
        if (typeof turnstile !== 'undefined') {
          try { turnstile.reset(); } catch (e) {}
        }

        setTimeout(function(){
          form.find('.message_after_call').remove();
        }, 4000);
      });

  });

});